import React from 'react';
import { Box, Typography, CircularProgress, Snackbar, Alert, IconButton, Tooltip } from '@mui/material';
import CloudDoneIcon from '@mui/icons-material/CloudDone';
import CloudOffIcon from '@mui/icons-material/CloudOff';
import SaveIcon from '@mui/icons-material/Save';

const SaveStatusIndicator = ({ isLoading, lastSaved, error, isGuest, onManualSave }) => {
  const [showError, setShowError] = React.useState(false);

  React.useEffect(() => {
    if (error) {
      setShowError(true);
    }
  }, [error]);

  if (isGuest) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, opacity: 0.7 }}>
        <CloudOffIcon fontSize="small" />
        <Typography variant="caption">Guest mode - data not saved</Typography>
      </Box>
    );
  }

  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        {isLoading ? (
          <>
            <CircularProgress size={16} sx={{ color: 'inherit' }} />
            <Typography variant="caption">Saving...</Typography>
          </>
        ) : lastSaved ? (
          <>
            <CloudDoneIcon fontSize="small" color="success" />
            <Typography variant="caption">
              Saved {new Date(lastSaved).toLocaleTimeString()}
            </Typography>
          </>
        ) : (
          <>
            <CloudOffIcon fontSize="small" />
            <Typography variant="caption">Click save to save</Typography>
          </>
        )}
        
        {/* Manual Save Button */}
        {onManualSave && !isGuest && (
          <Tooltip title="Save your data to Firebase">
            <IconButton
              size="small"
              onClick={onManualSave}
              disabled={isLoading}
              sx={{ 
                ml: 1, 
                color: lastSaved ? 'success.main' : 'primary.main',
                backgroundColor: lastSaved ? 'transparent' : 'action.hover',
                '&:hover': {
                  backgroundColor: 'action.selected'
                }
              }}
            >
              <SaveIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
      </Box>

      <Snackbar
        open={showError}
        autoHideDuration={6000}
        onClose={() => setShowError(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert severity="error" onClose={() => setShowError(false)}>
          {error || 'Failed to save data. Please try again.'}
        </Alert>
      </Snackbar>

    </>
  );
};

export default SaveStatusIndicator;